import React from 'react'
import $ from 'jquery'

import './FilterList.css'


class FilterList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            multiSelect: this.props.multiselect !== undefined,
            collapse: this.props.collapse !== undefined,
            selections: this.props.defSelections ? this.props.defSelections : []
        }

        this.processSelection = this.processSelection.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.clearFilter) {
            $('div.FilterList li.' + this.props.id).each(function () {
                $(this).removeClass("selected")
            })

            this.setState({ selections: [] })
        }
    }

    processSelection(e) {
        let _this = this
        let selection = e.currentTarget.innerHTML.split('<span')[0]
        let selections = this.state.selections

        if (!this.state.multiSelect) {
            $('div.FilterList li.' + _this.props.id).each(function () {
                $(this).removeClass("selected")
            })
        }

        if (this.state.multiSelect) {
            if (this.state.selections.includes(selection)) {
                let ndx = selections.indexOf(selection)

                selections.splice(ndx, 1)
                e.currentTarget.className = _this.props.id
            }
            else {
                selections.push(selection)
                e.currentTarget.className = "selected " + _this.props.id
            }
        }
        else {
            selections = [];
            selections.push(selection)
            e.currentTarget.className = "selected " + _this.props.id
        }

        this.setState({ selections: selections })

        this.props.processFilter(selections)
    }

    processCollapse(e) {
        if (e.target.className.includes('down')) {
            e.target.className = "fa fa-toggle-up pull-right"
            $(e.target.parentElement.parentElement.children[1]).css('display', 'block')
        }
        else {
            e.target.className = "fa fa-toggle-down down pull-right"
            $(e.target.parentElement.parentElement.children[1]).css('display', 'none')
        }
    }

    render() {
        return (
            <div className="FilterList">
                {
                    this.state.collapse ?
                        <p>{this.props.label}<i className="fa fa-toggle-up pull-right" onClick={this.processCollapse}></i></p>
                    :
                        <p>{this.props.label}</p>
                }
                {
                    this.props.filters && this.props.filters.length ?
                        <ul>
                            {
                                this.props.filters.map((filter, ndx) => {
                                    if (this.props.defSelections && this.props.defSelections.includes(filter.filter)) {
                                        let cls = "selected " + this.props.id

                                        return <li className={cls} key={ndx} onClick={this.processSelection}>{filter.filter}<span className="badge">{filter.count}</span></li>
                                    }
                                    else
                                        return <li key={ndx} className={this.props.id} onClick={this.processSelection}>{filter.filter}<span className="badge">{filter.count}</span></li>
                                })
                            }
                        </ul>
                    : null
                }
            </div>
        );
    }
}

export default FilterList
